import React from 'react';
import styles from './styles.module.scss';

export const Analytics = () => (
  <div className={styles.analyticsDashboard}>
    Future Analytics Page
  </div>
);

export default Analytics;
